import { Box } from '@mui/material'
import TitleWithIcon from '../../../../components/Cards/helpers/TitleWithIcon'
import UseTranslation from '../../../../hooks/UseTranslation'
import { ReactComponent as ActionIcon } from '../../../../images/ActionIcon.svg'
import OfoqTextArea from '../../../../components/Forms/OfoqTextArea'
import OfoqRadioBtn from '../../../../components/Forms/OfoqRadioBtn'

const Actions = ({
  comment, setComment, selectedAction, setSelectedAction,
}) => {
  const { t } = UseTranslation()
  const handleActionChange = (value) => {
    setSelectedAction(value)
  }

  return (
    <Box>
      <Box sx={styles.historyHeader}>
        <TitleWithIcon
          title={t?.['Your Action']}
          icon={<ActionIcon />}
          textVariant="heading4"
          customStyle={styles.titleWithIcon}
        />
      </Box>
      <Box sx={styles.radioGroup}>
        <OfoqRadioBtn
          name="approve"
          customPlaceHolder={t?.Approve}
          defaultOption={selectedAction === 'approve'}
          refState={() => handleActionChange('approve')}
          customStyle={selectedAction === 'approve' ? styles.approveStyle : {}}
        />
        <OfoqRadioBtn
          name="reject"
          customPlaceHolder={t?.Reject}
          defaultOption={selectedAction === 'reject'}
          refState={() => handleActionChange('reject')}
          customStyle={selectedAction === 'reject' ? styles.rejectStyle : {}}
        />
      </Box>

      <OfoqTextArea
        name={t?.['Add Comment']}
        customPlaceHolder={t?.['Type your comment Here']}
        refState={setComment}
        defaultValue={comment}
        customStyle={styles.textArea}
      />
    </Box>
  )
}

const styles = {
  historyHeader: {
    display: 'flex',
    alignItems: { xs: 'center', sm: 'baseline' },
  },
  titleWithIcon: {
    display: 'flex',
    alignItems: 'flex-start',
    margin: { xs: '10px 0px 0px 0px', sm: '20px 0px 0px 20px' },
    '& svg': {
      width: { xs: '15px', sm: '25px' },
      height: { xs: '15px', sm: '25px' },
    },
    '& span': {
      fontFamily: 'Avenir',
      marginLeft: '10px',
    },
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    padding: { xs: '0px 20px 0px 0px', sm: '20px 120px 0px 120px' },
    gap: { xs: '20px', sm: '0px' },
    marginTop: { xs: '20px', sm: '0px' },
    '& .MuiFormControlLabel-label': {
      textTransform: 'uppercase !important',
      fontSize: { xs: '12px', sm: '14px' },
    },
    '& .MuiFormControlLabel-root': {
      border: (theme) => ({
        xs: `1px solid ${theme.palette.grey[200]}`,
        sm: `2px solid ${theme.palette.grey[200]}`,
      }),
    },
    '& svg': {
      width: { xs: '12px', sm: '20px' },
      height: { xs: '12px', sm: '20px' },
    },
  },
  textArea: {
    margin: { xs: '0px ', sm: '-8px 0px 20px 50px ' },
    resize: 'none',
    '& label, textarea': {
      margin: { xs: '0px !important', sm: '0px 0px 0px 50px' },
      width: { xs: '100%', sm: '95%' },
    },
  },
  rejectStyle: {
    '& .MuiFormControlLabel-label': {
      color: 'error.main',
      fontWeight: 800,
    },
    '& .MuiSvgIcon-fontSizeMedium': {
      fill: (theme) => ` ${theme.palette.error.main}`,
    },
    '& .MuiFormControlLabel-root': {
      backgroundColor: 'background.lightRed',
      border: 'none !important',
    },
  },
  approveStyle: {
    '& .MuiFormControlLabel-label': {
      color: 'primary.main',
      fontWeight: 800,
    },
    '& .MuiSvgIcon-fontSizeMedium': {
      fill: (theme) => ` ${theme.palette.primary.main}!important`,
    },
    '& .MuiFormControlLabel-root': {
      backgroundColor: 'background.lightGreen',
      border: 'none !important',
    },
  },
}
export default Actions
